import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { OverlayLeft } from '../../components/Page/logix2020/OverlayLeft'
import OverlayLeftFilter from '../../components/Assets/OverlayLeftFilter'
import { Button, Spinner, Alert } from 'react-bootstrap'
import AssetsTable from '../../components/Assets/AssetsTable'
import styled from 'styled-components'
import { Subheader } from '../../components/Page/logix2020/Subheader'
import { useAssetsState } from '../../stores/AssetsProvider'
import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ActiveTableFilters from '../../components/Assets/ActiveTableFilters'
import { ContentArea } from '../../components/Page/logix2020/ContentArea'
import BigFooter from '../../components/Footer/BigFooter'
import useStores from '../../stores/useStore'
import { useObserver } from 'mobx-react'
import { isEmptyStr } from '../../utils/objectutils'
import useMountEffect from '../../utils/hooks/useMountEffect'

const StyledFilter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .btn {
    margin-left: 35px;
  }

  @media only screen and (max-width: 585px) {
    flex-direction: column;
    gap: 10px;

    .btn-res {
      width: 100%;
      margin-left: 0 !important;
      margin-right: 0 !important;
      margin-bottom: 5px !important;
    }

    .d-flex.flex-wrap.align-items-baseline {
      width: 100%;
      margin-bottom: 0 !important;
    }

    .btn {
      margin-left: 0;
    }
  }
`
const StyledSubheader = styled(Subheader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledContentArea = styled(ContentArea)`
  width: 100%;
  padding: 20px 30px 20px 36px;
  // height: 100% !important;
  @media (max-width: 426px) {
    padding: 20px;
  }
`

const AssetsOrderTablePageContent = () => {
  const {
    setShowAllAssets,
    showAllAssets,
    showInventoryableAssets,
    setShowOrderableAssets,
    filter,
    resetFilter,
    showOverlayLeft,
    setShowOverlayLeft,
    updateOverlayLeftStates,
  } = useAssetsState()
  const [selectedAsset, setSelectedAsset] = useState()
  const { t } = useTranslation()
  const currentLocation = useLocation()
  useMountEffect(() => {
    if (showInventoryableAssets) {
      resetFilter()
    }
  })
  useEffect(() => {
    let filterHasValues = false
    if (!showAllAssets) {
      const filterWithValues = { ...filter }
      delete filterWithValues['filter.orderProcessIsEnabled']
      Object.keys(filterWithValues).forEach((filterName) => {
        if (!isEmptyStr(filterWithValues[filterName])) {
          filterHasValues = true
        }
      })
    }
    if (filterHasValues || showAllAssets) {
      setShowOrderableAssets(true)
    }
  }, [filter, showAllAssets, showInventoryableAssets, setShowOrderableAssets])

  const onRowClick = (e, row) => {
    setSelectedAsset(row)
  }

  const handleCloseOverlayLeft = (e) => {
    setShowOverlayLeft(false)
    updateOverlayLeftStates()
  }
  if (selectedAsset) {
    return (
      <Navigate
        to={`/products/asset/${selectedAsset.id}`}
        state={{ from: currentLocation.pathname }}
      />
    )
  }

  return (
    <div>
      <StyledSubheader className='subHeader-v1'>
        <div className='subHeader-v1'>
          <div className='subheader-title'>{t('header:assetorder')}</div>
        </div>
      </StyledSubheader>

      <OverlayLeft
        className={`overlay-variant ${showOverlayLeft ? 'visible' : ''}`}
      >
        <div className='header' onClick={handleCloseOverlayLeft}>
          <span onClick={handleCloseOverlayLeft}>
            <i className='close-icon' />
          </span>
          <span className='header-title'>Filter</span>
        </div>
        <div className='body'>
          <OverlayLeftFilter />
        </div>
      </OverlayLeft>

      <StyledContentArea>
        <StyledFilter>
          <div className='d-flex flex-wrap align-items-baseline'>
            <Button
              variant='secondary'
              className='m-0 btn-res'
              onClick={() => {
                setShowOverlayLeft((prev) => !prev)
              }}
            >
              {t('allFilters')}
            </Button>
          </div>
          <div className='d-flex flex-wrap mb-2 align-items-baseline'>
            <Button
              variant='secondary'
              className='btn-extra-padding btn-res'
              onClick={() => {
                resetFilter()
                setShowAllAssets(true)
              }}
            >
              {t('assetPage:showAllAssets')}
            </Button>
          </div>
        </StyledFilter>
        <ActiveTableFilters />
        <AssetsTable onRowClick={onRowClick} noActions tableId='AssetsOrder' />
      </StyledContentArea>
      <BigFooter />
    </div>
  )
}
const AssetsOrderTablePage = () => {
  const { uiStore } = useStores()
  const { t } = useTranslation()
  const [error, setError] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => {
      setError(true)
    }, 3000)
    return () => clearTimeout(timer)
  }, [])

  return useObserver(() => (
    <>
      {!uiStore.allowOrderOnAssetEntities ? (
        <>
          <StyledSubheader className='subHeader-v1'>
            <div className='subHeader-v1'>
              <div className='subheader-title'>{t('header:order')}</div>
            </div>
          </StyledSubheader>
          {error ? (
            <Alert variant='danger'>{t('assetPage:accessDenied')}</Alert>
          ) : (
            <div className='d-flex align-items-center justify-content-center'>
              <Spinner animation='border' variant='primary' />
            </div>
          )}
        </>
      ) : (
        <AssetsOrderTablePageContent />
      )}
    </>
  ))
}
export default AssetsOrderTablePage
